<div class="flex items-center" *ngIf="user">
    <j-avatar [value]="user?.avatar || 'txt:' + (user?.username || user?.id).replace('.','')" [size]="size"></j-avatar>
    <span *ngIf="showName" class="ml-1-5 mr-1-5 user-name" [ngStyle]="style">{{ user?.name }}</span>
</div>
